angular.module('controllers').controller('orderChangedHistoryController', ['$scope', '$rootScope', '$controller', '$route', '$routeParams', '$location', 'Crud',
    function ($scope, $rootScope, $controller, $route, $routeParams, $location, Crud) {
        $rootScope.path = '/order-changed-history';
        $scope.path = $rootScope.path;
        $rootScope.modelName = 'order-changed-history';
        $scope.pathTemplate = 'orders/orderschangedhistory';
        $scope.title = 'Istoricul comenzilor accesate/modificate';

        angular.extend(this, $controller('crudController', {$scope: $scope}));

        $scope.sortType = 'id';
        $scope.defaultItem = 10;
        $rootScope.typeId = 'id';
        $scope.search.order = 'desc';
        $scope.classAction = 'td-big';
        $scope.columns = {
            //'id':{'label':'Id', 'filter':1, 'filterType':'input'},
            'order_no':{'label':'Nr. comanda', 'filter':1, 'filterType':'input'},
            'user_name':{'label':'Utilizator', 'filter':1, 'filterType':'input'},
            'driver_name':{'label':'Sofer', 'filter':1, 'filterType':'input'},
            'order_date_changed':{'label':'Data actiune', 'filter':1, 'filterType':'input'},
            'order_action_changed':{'label':'Actiune comanda', 'filter':1, 'filterType':'input'},
            'order_description_changed':{'label':'Descriere modificare', 'filter':1, 'filterType':'input'}
        };

        $scope.additionals['action'] = [
            {'id': 'Creare comanda', 'value': 'Creare comanda'},
            {'id': 'Modificare comanda', 'value': 'Modificare comanda'},
            {'id': 'Copiere comanda', 'value': 'Copiere comanda'},
            {'id': 'Stergere comanda', 'value': 'Stergere comanda'},
            {'id': 'Stergere multipla', 'value': 'Stergere multipla'},
            {'id': 'Modificare status comanda', 'value': 'Modificare status comanda'},
            {'id': 'Modificare cantitate produs', 'value': 'Modificare cantitate produs'},
            {'id': 'Stergere produs', 'value': 'Stergere produs'},
            {'id': 'Creare slot', 'value': 'Creare slot'},
            {'id': 'Editare slot', 'value': 'Editare slot'},
            {'id': 'Schimbare slot', 'value': 'Schimbare slot'},
            {'id': 'Stergere slot', 'value': 'Stergere slot'},
            {'id': 'Confirmare comanda', 'value': 'Confirmare comanda'}
        ];

        $scope.additionals['actions'] = {};
        $scope.additionals['actions'].options = $scope.additionals['action'];
        $scope.additionals['content_type'] = 'form-urlencoded';

        $scope.maxDate = new Date();
        $scope.minDate = '2010-01-01';
        var current_init_date = new Date();
        current_init_date.setHours(0, 0, 0, 0);
        $scope.search.dateFrom = current_init_date;

    }]
);
